import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

ProgramsCombosCreateModalController.$inject = ['$scope', '$uibModalInstance', 'HelpersService', 'combosList'];

function ProgramsCombosCreateModalController(
  $scope: IScope & {
    cancel: TODO;
    done: TODO;
    errors: TODO;
    hasErrors: TODO;
    init: TODO;
    isUnique: TODO;
    model: TODO;
    success: TODO;
    trim: TODO;
  },
  $uibModalInstance: UIBModal<TODO>,
  HelpersService: TODO,
  combosList: TODO
) {
  $scope.errors = [];

  $scope.model = {
    name: '',
    description: '',
  };

  $scope.init = function () {};

  $scope.hasErrors = function () {
    return $scope.errors.length > 0;
  };

  $scope.trim = function (s) {
    return s.replace(/\s+/g, '').toLowerCase();
  };

  $scope.isUnique = function () {
    let trimmed;
    const trimmedCurrent = $scope.trim($scope.model.name);
    let r = true;

    for (let i = 0, ii = combosList.length; i < ii; i++) {
      trimmed = $scope.trim(combosList[i].name);
      if (trimmedCurrent === trimmed) {
        r = false;
        break;
      }
    }

    return r;
  };

  $scope.done = function () {
    if ($scope.isUnique()) {
      $scope.model.description = HelpersService.strip($scope.model.description);
      $scope.model.name = HelpersService.strip($scope.model.name);
      if ($scope.model.name.replace(/\s+/g, '').length > 0) {
        $scope.success();
      } else {
        $scope.errors.push({ message: 'Please enter a valid name' });
      }
    } else {
      $scope.errors.push({ message: 'A combo named "' + $scope.model.name + '" already exists' });
    }
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close($scope.model);
  };

  $scope.init();
}

export const ProgramsCombosCreateModalControllerModule = angular
  .module('acme.view.application.programs.combos.createModal.controllers', ['acme.common.service.helpers'])
  .controller('ProgramsCombosCreateModalController', ProgramsCombosCreateModalController).name;
